/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Host/DOM API polyfills for the Chromium 52 baseline (LG webOS 3.x and similar
 * legacy embedded TV browsers).
 *
 * This is deliberately separate from `core-js/stable`, which is already in the
 * webpack entry. core-js polyfills **ECMAScript built-ins only** — it does not
 * touch host APIs such as `ResizeObserver` or `AbortController`, and Babel
 * cannot see them either, so every one of those has to be installed by hand.
 *
 * Loaded from the webpack `entry` array *before* `./src/index.tsx`, so the
 * globals exist before any component runs a layout effect. Import order matters:
 * do not import this from application code and expect it to have run first.
 *
 * `eslint.config.cjs` exempts this directory from `no-restricted-globals` and
 * `no-restricted-properties`, since defining the banned globals is precisely
 * what it is for.
 *
 * See docs/CHROMIUM-52-COMPATIBILITY.md (§ P1).
 */

/**
 * `AbortController` / `AbortSignal` (Chrome 66) — P1-1.
 *
 * A bare side-effect import, unlike the installers below, because the package
 * feature-detects and installs itself: it is a no-op unless `AbortController`
 * is missing or `Request.prototype` has no `signal`. It must be first, since
 * `@reduxjs/toolkit` and `react-router` both construct one during boot.
 *
 * The `polyfill-patch-fetch` build is deliberate. The plain build defines the
 * global but leaves `fetch` ignoring `signal`, which is the worse failure mode:
 * `fetch(url, { signal })` in `ThumbnailManager` would appear to work while
 * cancellation silently never happened.
 */
import "abortcontroller-polyfill/dist/polyfill-patch-fetch";

import { installResizeObserver } from "./resizeObserver";

installResizeObserver();
